<template>
  <div
    class="BulkOrderbysea"
    style="
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    "
  >
    <h4>海运散货订单</h4>
    <el-form
      ref="OrderQueryConditions"
      :label-position="labelPosition"
      :model="OrderQueryConditions"
      label-width="80px"
    >
      <el-form-item label="运单号">
        <el-input
          v-model="OrderQueryConditions.OrderCode"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="入仓仓库">
        <el-select
          v-model="OrderQueryConditions.InwareHouse"
          placeholder="请选择仓库"
        >
          <el-option
            :label="item.namec"
            :value="item.id"
            v-for="(item, index) in warehouseList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select style="visibility: hidden">
          <el-option></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="配送区域">
        <el-cascader
          clearable
          placeholder="请选择目的地"
          style="width: 200px"
          ref="changetoFABck"
          v-model="selectedHouseList"
          :options="houseList"
          :props="toFBAdataprops"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.namec }}</span>
            <span v-if="!node.isLeaf"></span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="委托日期">
        <el-date-picker
          v-model="OrderQueryConditions.EntrustmentData"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" style="margin-left: 0px" @click="onSubmit"
        >查询</el-button
      >
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
      <el-tab-pane
        :label="item.staus_desc"
        :name="item.order_status"
        v-for="(item, key) in tabsList"
        :key="key"
      >
        <el-table
          border
          align="center"
          :data="tableData"
          max-height="580"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          style="width: 95%; margin-left: 32px"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column type="selection" label="全选" min-width="5%"></el-table-column> -->
          <el-table-column
            type="index"
            label="序号"
            width="60px"
            min-width="8%"
          ></el-table-column>
          <el-table-column
            prop="nos"
            label="运单号"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="warehousename"
            label="入仓仓库"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="GoodsMessage"
            label="货物信息"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="Warehousing"
            label="入仓信息"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="EstimatedCost"
            label="预估费用"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="ActualCosts"
            label="实际费用"
            min-width="7%"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="轨迹"
            min-width="10%"
          ></el-table-column>
          <el-table-column
            prop="job_status"
            label="状态"
            min-width="10%"
          ></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="10%">
            <template slot-scope="scope">
              <el-button @click="orderdetails(scope)" type="text" size="small"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div style="">
      <el-pagination
        style="margin: 20px; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="curPageL"
        :pager-count="5"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "BulkOrderbysea",
  data() {
    return {
      selectedHouseList:[],
       toFBAdataprops: {
        label: "namec",
        value: "id",
        children: "datWarehouseDTOList",
      },
      houseList:[],
      total: 1000, //总条数
      pagesize: 20, //每页显示条数
      prefix: "",
      labelPosition: "left",
      activeName: "Z",
      tabsList: [
        { staus_desc: "全部", order_status: "one" },
        { staus_desc: "待入仓", order_status: "two" },
        { staus_desc: "已入仓", order_status: "three" },
        { staus_desc: "运输中", order_status: "four" },
        { staus_desc: "已到港", order_status: "five" },
        { staus_desc: "已到仓", order_status: "six" },
        { staus_desc: "派送中", order_status: "seven" },
        { staus_desc: "已派送", order_status: "eight" },
        { staus_desc: "已完成", order_status: "nine" },
        { staus_desc: "待付款", order_status: "ten" },
      ],
      tabListdata: [], //表单表头
      OrderQueryConditions: {
        //表单
        OrderCode: "", //运单号
        InwareHouse: "", //入仓仓库
        DestinationCountry: "", //目的国家
        DistributionArea: "", //配送区域
        EntrustmentData: [], //委托日期
      },
      tableData: [
        //table值
        // {
        //   "nos":"",//运单号
        //   "warehousename":"",//入仓仓库
        //   "GoodsMessage":"",//货物信息
        //   "Warehousing":"",//入仓信息
        //   "EstimatedCost":"",//预估费用
        //   "ActualCosts":"",//实际费用
        //   "job_status":"",//轨迹
        //   "state":"",//状态
        //   "operation":""//操作
        // }
      ],
      customerid: "", //运单号
      typeCode: "Z", //查询类型
      curPageL: 1,
      warehouseList: [], //仓库列表

      distributionList: [], //配送目的列表
    };
  },
  watch: {},
  methods: {
    handleSelectionChange(val) {
      //table方法
      this.multipleSelection = val;
    },
    tableDatas(list) {
      //接口数据对接table
      this.tableData = [];
      for (var i = 0; i < list.length; i++) {
        this.tableData.push(list[i]);
        this.tableData[i].GoodsMessage =
          list[i].goodescbefore +
          " " +
          list[i].goodcbmbefore +
          "CBM " +
          list[i].goodweightbefore +
          "KG";
        this.tableData[i].Warehousing =
          list[i].goodesc +
          " " +
          list[i].goodcbm +
          "CBM " +
          list[i].goodweight +
          "KG";
        this.tableData[i].EstimatedCost = this.tableData[
          i
        ].costbeforeinfo.amount1;
        this.tableData[i].ActualCosts = this.tableData[i].costinfo.amount2;
        if (this.tableData[i].state == 1) {
          this.tableData[i].Warehousing = "";
        }
      }
    },
    orderdetails(data) {
      //查看详情点击
      this.$router.push({
        name: "OrderDetails",
        query: { state: data.row.state, nos: data.row.nos },
      });
    },
    onSubmit() {
      //点击查询方法
      this.curPageL = 1;
      this.getAllOrder();
    },
    handleClick(activeName) {
      //tabs标签切换
      this.typeCode = activeName;
      this.getAllOrder(); //切换tabs
    },
    handleSizeChange(val) {
      //分页每页多少条
      this.pagesize = val;
      if (this.tabListdata.length > 0) {
        this.getAllOrder();
      }
    },
    handleCurrentChange(val) {
      //分页当前页
      this.curPageL = val;
      if (this.tabListdata.length > 0) {
        this.getAllOrder();
      }
    },
    warehouse() {
      //仓库id获取
      this.axios
        .get("/warehouse/warehouseListAll")
        .then((response) => {
          this.warehouseList = response.data.datas;
          let newda = {
            namec: "全部",
            id: "",
          };
          this.warehouseList.splice(0, 0, newda);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    territory() {
      //目的国家以及配送区域的id获取
      this.axios
        .get("/warehouse/overseasWarehouseList")
        .then((res) => {
            this.houseList = res.data.datas
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getAllOrder() {
      //获取全部订单
      if (this.OrderQueryConditions.DistributionArea == "全部") {
        this.OrderQueryConditions.DistributionArea = "";
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = ["", ""];
      }
      let data = {
        area: this.selectedHouseList[1], //配送区域
        beginTime: this.OrderQueryConditions.EntrustmentData[0]
          ? this.OrderQueryConditions.EntrustmentData[0]
          : "", //开始时间
        countryId: this.OrderQueryConditions.DestinationCountry, //国家id
        curPage: this.curPageL, //当前页，默认1
        customerid: this.customerid, //客户id
        endTime: this.OrderQueryConditions.EntrustmentData[1]
          ? this.OrderQueryConditions.EntrustmentData[1]
          : "", //结束时间
        language: "CN",
        nos: this.OrderQueryConditions.OrderCode, //运单号
        pageSize: this.pagesize, //每页数量，默认20
        type: this.typeCode, //运单状态类型
        warehouseid: this.OrderQueryConditions.InwareHouse, //仓库id
      };
      // console.log(data);
      let that = this;
      that.axios
        .post("/finance/getLclJobsHistoryWebList", data)
        .then(function (response) {
          // console.log(response.data.data);
          that.tabListdata = [];
          that.tabListdata = response.data.data.orderList;
          that.tableDatas(that.tabListdata);
          that.total = Number(response.data.data.totalCounts);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPansonageOrder() {
      //获取个人表头信息
      let data = {
        customerid: this.customerid,
        jobtype: "C",
        language: "CN",
      };
      this.axios
        .post("/finance/getJobCount", data)
        .then((response) => {
          let datas = response.data.data.statusList;
          this.tabsList = [];
          for (var i = 0; i < datas.length; i++) {
            this.tabsList.push(datas[i]);
            this.tabsList[i].staus_desc =
              datas[i].staus_desc + "(" + datas[i].counts + ")";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  created() {
    let publics = JSON.parse(localStorage.getItem("Authorization_lineSupplier"));
    this.customerid = publics.customerid;
  },
  mounted() {
    this.getAllOrder();
    this.warehouse();
    this.territory();
    this.getPansonageOrder();
  },
};
</script>
<style scoped>
.el-table >>> th.gutter {
  display: table-cell !important;
}
.el-table th.gutter {
  display: table-cell !important;
}
.BulkOrderbysea {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.BulkOrderbysea h4 {
  width: 100%;
  height: 24px;
  padding-top: 30px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
}
.BulkOrderbysea footer {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  position: relative;
  box-sizing: border-box;
}
/* footer .el-pagination{
  position: absolute;
  right: 50px;
  width: 620px;
  box-sizing: border-box;
} */
.BulkOrderbysea .el-form {
  margin-top: 20px;
  margin-left: 31px;
}
.BulkOrderbysea .el-form .el-input {
  width: 68%;
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-color: #e7e7e7;
  border-radius: 5px;
}
.BulkOrderbysea .el-form .el-input--suffix {
  width: 100%;
}
.BulkOrderbysea .el-select {
  width: 68%;
}
.BulkOrderbysea .el-date-editor--daterange.el-input,
.BulkOrderbysea .el-date-editor--daterange.el-input__inner,
.BulkOrderbysea .el-date-editor--timerange.el-input,
.BulkOrderbysea .el-date-editor--timerange.el-input__inner {
  width: 68%;
}
.BulkOrderbysea .el-form-item,
.el-form-item--small.el-form-item {
  width: 33%;
  display: inline-block;
}
.BulkOrderbysea .el-button--primary {
  width: 102px;
  height: 36px;
  padding: 0;
  background: #604aff;
  border-radius: 5px;
  border: none;
}
.BulkOrderbysea .el-tabs__header {
  margin: 0px 30px 15px;
}
.BulkOrderbysea .el-tabs__nav-wrap::after {
  background: none;
}
.BulkOrderbysea .el-table td,
.el-table th {
  text-align: center;
}
.BulkOrderbysea .el-tabs__item.is-active {
  color: #343434;
}
.BulkOrderbysea .el-tabs__item {
  color: #9a9a9a;
}
.BulkOrderbysea .el-table__body-wrapper {
  height: 530px !important;
}
/* table 滚动条 */
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/BulkOrder/BulkOrderbysea.vue